module.exports = __webpack_public_path__ + "static/media/tutorial.e3f45f9a.png";